import { motion } from "motion/react";
import "./Skeleton.scss";

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  variant?: "text" | "circular" | "rectangular";
  className?: string;
  style?: React.CSSProperties;
}

const variantStyles: Record<string, React.CSSProperties> = {
  text: { borderRadius: 4, height: "1em", width: "100%" },
  circular: { borderRadius: "50%" },
  rectangular: { borderRadius: 4 },
};

const shimmer = {
  backgroundPosition: ["100% 50%", "0% 50%"],
};

const Skeleton: React.FC<SkeletonProps> = ({
  width,
  height,
  borderRadius,
  variant = "rectangular",
  className = "",
  style,
}) => {
  const base = variantStyles[variant];

  return (
    <motion.div
      className={`skeleton ${className}`}
      animate={shimmer}
      transition={{ duration: 1.4, ease: "easeInOut", repeat: Infinity }}
      style={{
        ...base,
        ...(width !== undefined && { width }),
        ...(height !== undefined && { height }),
        ...(borderRadius !== undefined && { borderRadius }),
        ...style,
      }}
    />
  );
};

export default Skeleton;
